import React, { useState } from "react";
import BoroughDropdown from "../../customHooks/boroughDropdown";
import WardDropdown from "../../customHooks/wardDropdown";
import StreetDropdown from "../../customHooks/streetdropdown";
import { API_URLS } from "../../../apiUrl";
import axiosInstance from "../../../components/axiosInstance";

const AddHoldingNo = ({ muniCipalityName, muniCipalityId }: any) => {
  const [formData, setFormData] = useState<any>({
    municipalityTbl_id: muniCipalityId,
    borough_tbl_id: "",
    ward_tbl_id: "",
    street_name: "",
    street_primary_id: "",
  });

  const [bulk_data, setbulk_data] = useState<File | null>(null);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [isSampleDownloaded, setIsSampleDownloaded] = useState(false);
  const [dataExistMessage, setDataExistMessage] = useState<string>("");
  const [dataFailedMessage, setDataFailedMessage] = useState<string>("");

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setbulk_data(file);
  };

  const [, , , boroughList] = BoroughDropdown(muniCipalityId);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [, , , wardList] = WardDropdown(muniCipalityId, formData.borough_tbl_id);

  const [, , , streetList] = StreetDropdown(muniCipalityId, formData.ward_tbl_id);

  const downloadSampleCSV = () => {
    const sampleData = [
      { municipality: muniCipalityId, borough: formData.borough_tbl_id, ward: formData.ward_tbl_id, street: formData.street_primary_id }
    ];

    const csvContent = [
      ["municipality", "borough", "Ward no", "Street code", "Apartment Name", "Landmark", "Holding_no", "AssesseeName", "Father Spouse Name", "Holding _type", "Year_Of_Last_Assessment", "Mouza_Name", "JL No.", "Khatiyan No", "Plot No", "La_Acar", "La_Bigha", "La_Katha", "La_Chatak", "La_Sqft", "La_Satak_Decimal", "Total_La_SQFT", "Covered_Area", "Annual_Valuation", "qtr_proptax"
      ],
      ...sampleData.map((item) => [item.municipality, item.borough, item.ward, item.street, "", "", "1", "SUDAM SAKHA", "", "PUCCA & Kachha", "2020", "ABASBARI CHAR", "", "", "", "", "", "1", "2", "5", "", "", "1230", "760", "190"]),
    ]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "bulk_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setIsSampleDownloaded(true);
  };

  const isDownloadButtonEnabled = () => {
    return formData.borough_tbl_id && formData.ward_tbl_id && formData.street_primary_id;
  };

  const handleFileUpload = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!bulk_data) {
      alert("Please select a file to upload");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("bulk_data", bulk_data);

    try {
      const response = await axiosInstance.post(`${API_URLS.BulkHoldingData}`, formDataToSend);

      if (response.data.data.data.insertedRecords?.length > 0) {
        const holdingNumbers = response.data.data.data.insertedRecords?.map((holding: any) => holding.Holding_no).join(', ');
        setSuccessMessage(`Bulk holding data inserted successfully: ${holdingNumbers}`);
      } else if (response.data.data.data.duplicateRecords?.length > 0 && response.data.data.data.insertedRecords?.length === 0) {
        setDataExistMessage("Holding Numbers already exists for this municipality!");
      } else {
        setDataFailedMessage("Holding No. add failed!");
      }
    } catch (error) {
      console.error("Error while uploading CSV:", error);
      setDataFailedMessage("CSV upload failed.");
    } finally {
      setFormData({
        municipalityTbl_id: muniCipalityId,
        borough_tbl_id: "",
        ward_tbl_id: "",
        street_name: "",
        street_primary_id: "",
      });
      setbulk_data(null);
    }

    setTimeout(() => {
      setSuccessMessage("");
      setDataExistMessage("");
      setDataFailedMessage("");
    }, 5000);
  };

  return (
    <div className="max-w-full mx-auto">
      <div className="flex flex-col gap-5">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Add Holding No.</h1>
        <div className="p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800">
          <form onSubmit={handleFileUpload}>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
              <div>
                <label htmlFor="property_type_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Municipality <span className="text-red-600">*</span>
                </label>
                <div className="relative">
                  <input
                    type="text"
                    value={muniCipalityName}
                    id="type_description_name"
                    name="type_description_name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    disabled
                  />
                </div>
              </div>

              <div>
                <label htmlFor="borough_tbl_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Borough <span className="text-red-600">*</span>
                </label>
                <div className="relative">
                  <select
                    id="borough_tbl_id"
                    name="borough_tbl_id"
                    value={formData.borough_tbl_id}
                    onChange={handleChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value="">Select Borough</option>
                    {boroughList?.map((borough: any) => (
                      <option key={borough.borough_primary_id} value={borough.borough_primary_id}>
                        {borough.borough_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="ward_tbl_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Ward <span className="text-red-600">*</span>
                </label>
                <div className="relative">
                  <select
                    id="ward_tbl_id"
                    name="ward_tbl_id"
                    value={formData.ward_tbl_id}
                    onChange={handleChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value="">Select Ward</option>
                    {wardList?.map((ward: any) => (
                      <option key={ward.ward_primary_id} value={ward.ward_primary_id}>
                        {ward.ward_no}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="street_primary_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Street <span className="text-red-600">*</span>
                </label>
                <div className="relative">
                  <select
                    id="street_primary_id"
                    name="street_primary_id"
                    value={formData.street_primary_id}
                    onChange={handleChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value="">Select Street</option>
                    {streetList?.map((street: any) => (
                      <option key={street.street_primary_id} value={street.street_primary_id}>
                        {street.street_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="file-upload" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Bulk Upload (CSV, Excel) <span className="text-red-600">*</span>
                </label>
                <div className="flex items-center">
                  <input
                    type="file"
                    id="file-upload"
                    name="file-upload"
                    accept=".csv, .xls, .xlsx"
                    onChange={handleFileChange}
                    disabled={!isDownloadButtonEnabled() || !isSampleDownloaded}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:opacity-50"
                  />
                  {bulk_data && (
                    <span className="ml-4 text-gray-700 dark:text-gray-400">
                      {bulk_data.name}
                    </span>
                  )}
                </div>
              </div>

              <div className="lg:col-span-2 sm:col-span-2">
                <div className="flex gap-x-2">
                  <button
                    type="button"
                    onClick={downloadSampleCSV}
                    disabled={!isDownloadButtonEnabled() || isSampleDownloaded === true}
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-50"
                  >
                    Download Sample
                  </button>

                  <button
                    type="submit"
                    disabled={!isSampleDownloaded || !isDownloadButtonEnabled()}
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-50"
                  >
                    Upload CSV
                  </button>
                </div>
              </div>
            </div>
          </form>

          {successMessage && (
            <div className="mt-4 p-4 bg-green-600 text-white rounded-lg flex justify-between items-center">
              <span>{successMessage}</span>
              <button
                onClick={() => setSuccessMessage('')}
                className="ml-4 text-white font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}

          {dataExistMessage && (
            <div className="mt-4 p-4 bg-yellow-500 text-black rounded-lg flex justify-between items-center">
              <span>{dataExistMessage}</span>
              <button
                onClick={() => setDataExistMessage('')}
                className="ml-4 text-black font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}

          {dataFailedMessage && (
            <div className="mt-4 p-4 bg-red-500 text-black rounded-lg flex justify-between items-center">
              <span>{dataFailedMessage}</span>
              <button
                onClick={() => setDataFailedMessage('')}
                className="ml-4 text-black font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddHoldingNo;